import React, {Component} from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

class DatepickerHours extends Component {
  render() {
    const {getStartDate, handleChange, getExcludeDates, today, numberDatepicker, handleDateChangeRaw, tomorrow, fromto, numberHourPicker, isDisabledHourPicker} = this.props;
    const isToday = moment(getStartDate(numberDatepicker)).format("YYYY-MM-DD") === moment(today).format("YYYY-MM-DD")
    const isDisabled = getStartDate(numberDatepicker) ? false : true;
    const isDisabledHours = isDisabledHourPicker || numberHourPicker === '1' ? false : true;
    return (
      <div>
        <DatePicker
          readOnly={isDisabled || isDisabledHours}
          selected={getStartDate(numberDatepicker, fromto)}
          onChange={(date) => handleChange(numberDatepicker, date, fromto)}
          minTime={moment().hours(8).minutes(0).toDate()}
          maxTime={moment().hours(20).minutes(0).toDate()}
          excludeTimes={getExcludeDates}
          timeIntervals={60}
          timeCaption="Time"
          dateFormat="HH:mm"
          timeFormat="HH:mm"
          onChangeRaw={handleDateChangeRaw}
          showTimeSelect
          showTimeSelectOnly
        />
      </div>
    );
  }
}

export default DatepickerHours;


// WEBPACK FOOTER //
// ./src/components/Datepicker/DatepickerHours.js